var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu_1_",
    "data-name": "menu (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.445,
    height: 14.044,
    viewBox: "0 0 19.445 14.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8315",
    "data-name": "Path 8315",
    d: "M18.635,124.288H.81a.81.81,0,0,1,0-1.62H18.635a.81.81,0,0,1,0,1.62Zm0,0",
    transform: "translate(0 -116.456)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8316",
    "data-name": "Path 8316",
    d: "M18.635,1.62H.81A.81.81,0,0,1,.81,0H18.635a.81.81,0,1,1,0,1.62Zm0,0",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8317",
    "data-name": "Path 8317",
    d: "M18.635,246.952H.81a.81.81,0,0,1,0-1.62H18.635a.81.81,0,0,1,0,1.62Zm0,0",
    transform: "translate(0 -232.909)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.c69320f740ac21470f6603ef5de8cc4f.svg";
export { ForwardRef as ReactComponent };